import script from "./QuestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionList.vue?vue&type=script&setup=true&lang=js"

export default script